"use strict";

import "./Toast.css";

export default class Toast {
	
	constructor(content, color) {
		
		if (!content)
			throw new Error("Missing content");
		
		this.wrapper = document.createElement("div");
		this.wrapper.classList.add("Toast");
		document.body.appendChild(this.wrapper);
		
		if (color) {
			if (color.toLowerCase() == 'orange') this.wrapper.classList.add('Orange');
			if (color.toLowerCase() == 'green') this.wrapper.classList.add('Green');
			if (color.toLowerCase() == 'red') this.wrapper.classList.add('Red');
		}
		
		if (content.constructor === String) {
			this.wrapper.textContent = content;
		}
		else if (content instanceof Element) {
			this.wrapper.appendChild(content);
		}
		
		setTimeout(() => document.body.removeChild(this.wrapper), Toast.TIMEOUT);
	}
}

Toast.TIMEOUT = 5000;


// WEBPACK FOOTER //
// ./~/vwa/components/Toast/Toast.js